import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import * as ApiConst from '../../constants/Api';
import * as LocalStorageUtils from '../../utils/LocalStorage';
import * as LocalStorageConst from '../../constants/LocalStorage';
import {
    register,
    showRegModal,
    showAuthModal
} from '../../actions/User';
import * as RoutePaths from "../../constants/RoutePaths";

const defaultProps = {
    showRegModal: isShowRegModal => {
    },
    showAuthModal: isShowAuthModal => {
    }
};

class Registration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowRegForm: false,
            termsAccepted: false,
            privatePolicyAccepted: false
        }
    }

    showAuthModal(event, isShowAuthModal) {
        event.preventDefault();

        this.props.showAuthModal(isShowAuthModal);
    }

    showRegModal(event, isShowRegModal) {
        event.preventDefault();

        this.props.showRegModal(isShowRegModal);
    }

    showRegForm(event) {
        event.preventDefault();

        this.setState(prevState => ({
            isShowRegForm: !prevState.isShowRegForm
        }))
    }

    handleClickRegisterFacebook = event => {
        event.preventDefault();

        LocalStorageUtils.set(LocalStorageConst.KEYS.PATHNAME_AFTER_AUTH, this.props.location.pathname);
        window.location.href = ApiConst.FACEBOOK_LOGIN_URL;
    };

    register(event) {
        event.preventDefault();

        this.props.register(this.email.value, this.password.value);
    }

    render() {
        const i18n = this.props.i18n;

        return (
            <ReactModal
                className="popup register"
                overlayClassName="popup-overlay"
                isOpen={this.props.isShowRegModal}
            >
                <div onClick={(event) => this.showRegModal(event, false)} className="popup-close"/>
                <div className="popup-title">
                    {i18n['registration.registration']}
                </div>
                <div className="auth-with">
                    <a href="" className="fb" onClick={this.handleClickRegisterFacebook}>
                        <span/>
                        {i18n['registration.viaFacebook']}
                    </a>
                    <a href="" className="by-mail" onClick={::this.showRegForm}>
                        <span/>
                        {i18n['registration.viaEmail']}
                    </a>
                </div>

                <div className="popup-enter-action">
                    <div>{i18n['registration.byRegisteringYouAgreeWith']}</div>
                    <div>
                        <a href={RoutePaths.AGREEMENT} className="pink" style={{display: 'inline-block'}}>
                            {i18n['registration.termsOfService']}
                        </a>&nbsp;

                        <input type='checkbox' checked={this.state.termsAccepted} onChange={(e) => {
                            this.setState({termsAccepted: e.target.checked})
                        }}/>
                    </div>
                    <div>
                        <a href={RoutePaths.PRIVACY} className="pink" style={{display: 'inline-block'}}>
                            {i18n['registration.privacyPolicy']}
                        </a>&nbsp;

                        <input type='checkbox' checked={this.state.privatePolicyAccepted} onChange={(e) => {
                            this.setState({privatePolicyAccepted: e.target.checked})
                        }}/>
                    </div>
                </div>

                {this.state.isShowRegForm && <form>
                    <input
                        type="email"
                        placeholder="E-mail"
                        className="text-field"
                        ref={ref => {
                            this.email = ref
                        }}
                    />
                    <input
                        type="password"
                        className="text-field"
                        placeholder={i18n['registration.password']}
                        ref={ref => {
                            this.password = ref
                        }}
                    />
                    <div
                        className="submit-box"
                        style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <button className="btn" type="submit" onClick={::this.register} disabled={!this.state.termsAccepted || !this.state.privatePolicyAccepted}>
                            {i18n['registration.register']}
                        </button>
                    </div>
                </form>}

                <div className="popup-enter-action enter-link">
                    <div>{i18n['registration.youAreAlreadyRegistered']}?</div>
                    <a href="" onClick={(event) => this.showAuthModal(event, true)} className="pink">
                        {i18n['registration.signIn']}
                    </a>
                </div>
            </ReactModal>
        )
    }
}

Registration.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    isShowRegModal: state.user.isShowRegModal
});

const mapDispatchToProps = {
    register,
    showRegModal,
    showAuthModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Registration));



// WEBPACK FOOTER //
// ./src/components/Base/Registration.js